/* ========== Drop Monday — Cart Toast (Checkout Pop) ==========
   Shows after successful add-to-cart (listens to theme cart:update events)
*/
(() => {
  const TOAST_CLASS = 'dm-cart-toast';
  const OPEN_CLASS = 'is-open';
  const DISPLAY_MS = 4500;

  // Only show toast for "add" sources (avoid showing on quantity changes inside cart)
  const shouldShowForSource = (source) => {
    const s = String(source || '').toLowerCase();
    return (
      s.includes('product-form') ||
      s.includes('quick-order') ||
      s.includes('quick-add') ||
      s.includes('quick-view') ||
      s.includes('dm-featured-collection')
    );
  };

  const mount = () => {
    let el = document.querySelector(`.${TOAST_CLASS}`);
    if (el) return el;

    el = document.createElement('div');
    el.className = TOAST_CLASS;
    el.innerHTML = `
      <div class="dm-cart-toast__card" role="status" aria-live="polite">
        <div class="dm-cart-toast__text">
          <div class="dm-cart-toast__title">Added to cart</div>
          <div class="dm-cart-toast__sub" data-dm-toast-sub>Ready to checkout?</div>
        </div>

        <div class="dm-cart-toast__actions">
          <a class="dm-cart-toast__btn dm-cart-toast__btn--ghost" href="/cart">View cart</a>
          <a class="dm-cart-toast__btn dm-cart-toast__btn--primary" href="/checkout">Checkout</a>
          <button type="button" class="dm-cart-toast__close" aria-label="Close">×</button>
        </div>
      </div>
    `.trim();

    document.body.appendChild(el);

    const closeBtn = el.querySelector('.dm-cart-toast__close');
    closeBtn?.addEventListener('click', () => hide(true));

    document.addEventListener('keydown', (ev) => {
      if (ev.key === 'Escape') hide(true);
    });

    return el;
  };

  let timer = null;

  const show = (message) => {
    const el = mount();
    const sub = el.querySelector('[data-dm-toast-sub]');
    if (sub && message) sub.textContent = message;

    el.classList.add(OPEN_CLASS);

    clearTimeout(timer);
    timer = window.setTimeout(() => hide(false), DISPLAY_MS);
  };

  const hide = (force) => {
    const el = document.querySelector(`.${TOAST_CLASS}`);
    if (!el) return;

    el.classList.remove(OPEN_CLASS);
    if (force) clearTimeout(timer);
  };

  document.addEventListener('cart:update', (e) => {
    try {
      const detail = e && e.detail ? e.detail : {};
      const data = detail.data || {};
      if (data.didError) return;
      if (!shouldShowForSource(data.source)) return;

      const count = data.itemCount;
      const msg =
        typeof count === 'number'
          ? `Cart updated (${count} item${count === 1 ? '' : 's'}). Checkout now?`
          : 'Ready to checkout?';

      show(msg);
    } catch (_) {}
  });
})();
